import React, {Component} from 'react';

import Fields from './fields.js';
import './item.css';

export default class Item extends Component {

  constructor(props) {
    super(props);
    this.changeNewType = this.changeNewType.bind(this);
    this.addNewField = this.addNewField.bind(this);
    this.renderItemSave = this.renderItemSave.bind(this);
  }

  changeNewType(e) {
    this.props.changeNewType(e.target.value);
  }

  addNewField() {
    if (this.props.newType === 'required_text') {
      this.props.addNewRequiredTextField();
    } else if (this.props.newType === 'optional_text') {
      this.props.addNewOptionalTextField();
    } else if (this.props.newType === 'drop_down') {
      this.props.addNewDropDownField();
    } else {
      throw new Error(`Unhandled newType ${this.props.newTypue}`);
    }
  }

  handleSave() {
    this.props.saveCustomisations();
  }

  renderItemSave() {
    if (this.props.touched()) {
      if (this.props.validate()) {
        return (
          <div className="Item__save">
            <button
              className="Item__save--touched button"
              onClick={this.props.saveCustomisations}
            >Save changes</button>
          </div>
        );
      } else {
        return (
          <div className="Item__save">
            <button className="Item__save--touched button" disabled>Save changes</button>
          </div>
        );
      }
    } else {
      if (this.props.beenSaved) {
        return (
          <div className="Item__save">
            <div className="Item__save--untouched">
              <span>Saved!</span>
              <a href={this.props.item.url}>View the item &rarr;</a>
            </div>
          </div>
        );
      } else {
        return (
          <div className="Item__save">
            <div className="Item__save--untouched"></div>
          </div>
        );
      }
    }
  }

  renderAddNewCustomisation() {
    return (
      this.props.item.customisations.length < 4 ?
        <button
          type="button"
          className="Item__customisations__new__add"
          onClick={this.addNewField}
        >Add</button> :
        <button
          type="button"
          className="Item__customisations__new__add"
          disabled
        >Add</button>
    );
  }

  render() {
    return (
      <section className="Item">
        <section className="block">
          <header className="Item__header">
            <h1 className="Item__header__title">Add variations to this item</h1>
            <a href={this.props.item.url}>&larr; Back to item</a>
          </header>
          <div className="Item__hint hint">
            <p className="hint">
              You can offer customers options for your items eg. sizes, colours, personalised
              text and extras like framing. When adding options think about your customer and
              make the process as simple as possible. Only add necessary variations.
            </p>
          </div>
          <a className="Item__link" href={this.props.item.url} target="_blank">
            <h3 className="Item__title">{this.props.item.title}</h3>
            <img className="Item__image" src={this.props.item.image_url} alt=""/>
          </a>
        </section>
        <section className="block">
          <div className="Item__customisations">
            <header className="Item__customisations__header">
              <h3>Your item variations:</h3>
              <p className="hint">
                You can set up to 4 options for your listing. There are 3 types of variations to
                choose from below.
              </p>
            </header>
            <Fields
              customisations={this.props.item.customisations}
              changeName={this.props.changeName}
              changeLabel={this.props.changeLabel}
              changePrice={this.props.changePrice}
              deleteCustomisation={this.props.deleteCustomisation}
              addNewDropDownOption={this.props.addNewDropDownOption}
              deleteDropDownOption={this.props.deleteDropDownOption}
              changeOptionValue={this.props.changeOptionValue}
              changeOptionPrice={this.props.changeOptionPrice}
            />
            <div className="Item__customisations__ui-options">
              <div>
                <h4>Choose a type of variation to add:</h4>
                <select
                  className="Item__customisations__new__type"
                  value={this.props.newType}
                  onChange={this.changeNewType}
                >
                  <option value="drop_down">Drop down</option>
                  <option value="required_text">Text (required)</option>
                  <option value="optional_text">Text (optional)</option>
                </select>
                {this.renderAddNewCustomisation()}
              </div>
              {this.renderItemSave()}
            </div>
          </div>
        </section>
      </section>
    );
  }

};



// WEBPACK FOOTER //
// ./src/app/item-customisations/item.js